"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.QuestionItem = void 0;
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const clearTagFromString = (inputString)=>inputString.replaceAll(/<\/?[^>]+(>|$)/g, '');
const QuestionItem = (param)=>{
    let { questionItem, truncate } = param;
    var _questionItem_question;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        href: questionItem.answerUrl,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Title, {
                truncate: truncate,
                children: clearTagFromString((_questionItem_question = questionItem.question) !== null && _questionItem_question !== void 0 ? _questionItem_question : '')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Icon, {
                className: "icon v-icon-arrow-right-thin"
            })
        ]
    });
};
exports.QuestionItem = QuestionItem;
